import { apiClient } from "./apiClient";

export default {
  get(orgId) {
    return apiClient.get(`/rest/customSupport?orgId=${orgId ? orgId : ""}`);
  },

  update(orgId, params) {
    return apiClient.put(
      `/rest/customSupport?orgId=${orgId ? orgId : ""}`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },
};
